import React from 'react';

interface StepperProgressProps {
  percent: number;
  className?: string;
}

const StepperProgress: React.FC<StepperProgressProps> = ({
  percent,
  className,
}) => (
  <div
    className={['progress', className].filter(Boolean).join(' ')}
    role='progressbar'
    aria-valuenow={percent}
    aria-valuemin={0}
    aria-valuemax={100}
    aria-label='Linear progress'
  >
    <div
      className='progress-bar'
      style={
        {
          width: `${percent}%`,
          '--val': `${percent}%`,
        } as React.CSSProperties
      }
    ></div>
  </div>
);

export default StepperProgress;
